import type { LayerEffectsInfo, TextStyle } from "ag-psd";
import type Konva from "konva";
import { artRgbColor } from "../../lib/schedule-art/art-color";

export function psdTextStroke(text: Konva.Text): {
  style: TextStyle;
  effects?: LayerEffectsInfo;
} {
  const disabledStyle = { fillFlag: true, strokeFlag: false };
  if (!text.hasStroke()) return { style: disabledStyle };

  const stroke = text.stroke();
  if (typeof stroke !== "string") {
    throw new Error("Unsupported PSD text stroke color");
  }
  const rgb = artRgbColor(stroke);
  if (!rgb) throw new Error("Unsupported PSD text stroke color");
  const color = { r: rgb.r, g: rgb.g, b: rgb.b };
  const outside = text.fillAfterStrokeEnabled();
  if (outside) {
    return {
      style: disabledStyle,
      effects: {
        scale: 1,
        stroke: [
          {
            enabled: true,
            present: true,
            showInDialog: true,
            position: "outside",
            size: { units: "Pixels", value: text.strokeWidth() / 2 },
            fillType: "color",
            blendMode: "normal",
            opacity: 1,
            color,
          },
        ],
      },
    };
  }

  return {
    style: {
      fillFlag: true,
      strokeFlag: true,
      fillFirst: true,
      strokeColor: color,
      outlineWidth: text.strokeWidth(),
    },
  };
}
